import axios from "axios";
import { config } from "../config/config";
import { endAdminSession, getAdminToken } from "../utils/adminAuth";

const instance = axios.create({
  baseURL: config.backendUrl,
  headers: {
    "Content-Type": "application/json",
  },
});

instance.interceptors.request.use(
  (request) => {
    const token = getAdminToken();
    if (token) request.headers.authorization = `Bearer ${token}`;
    return request;
  },
  (error) => Promise.reject(error)
);

// A rejected token means the session is over — expired, or revoked by a secret change.
// Dropping it here keeps the panel from looping on requests that can never succeed.
instance.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;
    if (status === 401 || status === 403) endAdminSession();
    return Promise.reject(error);
  }
);

export default instance;
